import "./FileViewer.css";

import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { Document, Page, pdfjs } from "react-pdf";
import React, { memo, useEffect, useRef, useState } from "react";


import DXFFileViewer from "./DXFFileViewer";
import { toYoutubeEmbedUrl } from "Helper/utils/youtubeEmbedUrl";
import Iframe from "react-iframe";
import ImageLoader from "Hooks/ImageLoader";
import STEPFileViewer from "./STEPFileViewer";
import STLFileViewer from "./STLFileViewer";


const AppFileViewer = () => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  const path = localStorage.getItem("filePath");
  let filePath = localStorage.getItem("filePath");
  const fileType = localStorage.getItem("fileType");
  const folderType = localStorage.getItem("folderType");
  const disableHeader = localStorage.getItem("disableHeader");

  const imageFileTypeArray = ["jpg", "png", "jpeg"];
  const videoFileTypeArray = ["mp4", "mkv", "webm"];
  const cadFileTypeArray = ["step", "stp"];

  const fileExt = fileType?.toLowerCase()?.toString();
  const isPdf = fileExt === "pdf";
  const isVideo = videoFileTypeArray.includes(fileExt);
  const isImage = imageFileTypeArray.includes(fileExt);
  const isCADSTEP = cadFileTypeArray.includes(fileExt);
  const isCADSTL = fileExt === "stl";
  const isCADDXF = fileExt === "dxf";
  const isWord = fileExt === "doc" || fileExt === "docx";
  const isPowerPoint = fileExt === "ppt" || fileExt === "pptx";
  const isHeaderDisabled = disableHeader || false;
  const isExcel =
    fileType?.toLowerCase() === "xls" ||
    fileType?.toLowerCase() === "xlsx";
  if (folderType === "webLink" && filePath) {
    filePath = toYoutubeEmbedUrl(filePath);
  }

  const [numPages, setNumPages] = useState(null);
  const [isLoding, setIsLoading] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [zoom, setZoom] = useState(1);
  const [inputValue, setInputValue] = useState(1);
  const [containerWidth, setContainerWidth] = useState(300);

  const docs = [{ uri: filePath, fileType: fileType }];
  const containerRef = useRef(null);

  useEffect(() => {
    setTimeout(() => setIsLoading(false), 2000);
  }, []);

  useEffect(() => {
    const handleContextMenu = (event) => event.preventDefault();
    document.addEventListener("contextmenu", handleContextMenu);
    return () => document.removeEventListener("contextmenu", handleContextMenu);
  }, []);

  useEffect(() => {
    if (!containerRef.current) return;
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        setContainerWidth(entry.contentRect.width);
      }
    });
    resizeObserver.observe(containerRef.current);
    return () => resizeObserver.disconnect();
  }, []);

  useEffect(() => {
    setInputValue(pageNumber);
  }, [pageNumber]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  useEffect(() => {
    function updateWidth() {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    }
    updateWidth();

    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  return isLoding ? (
    <ImageLoader />
  ) : (
    <div
      className="file-view-documents"
      style={{
        width: "100%",
        maxWidth: "100%",
        overflowX: "hidden",
        display: isVideo ? "flex" : undefined,
        justifyContent: isVideo ? "center" : undefined,
      }}
    >
      {folderType === "webLink" ? (
        <Iframe
          url={filePath}
          width="100%"
          height="100%"
          id="filePath"
          frameBorder={0}
          display="block"
          position="relative"
          style={{ maxWidth: "100%" }}
        />
      ) : isPdf ? (
        <>
          <div className="pdf-viewer-top-bar">
            <span className="pdf-viewer-top-bar-hint">
              If loading is taking time, try opening in your browser&apos;s default viewer.
            </span>
            <button
              type="button"
              className="pdf-open-default-btn"
              onClick={() => window.open(filePath, "_blank")}
              title="Open PDF in new tab"
            >
              <span className="pdf-open-default-btn-icon" aria-hidden>↗</span>
              View in default viewer
            </button>
          </div>
          <Iframe
            // url={`https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(filePath)}`}
              url={`/pdfjs/web/viewer.html?file=${encodeURIComponent(filePath)}`}

            width="100%"
            height="100%"
          />
        </>
      ) : isVideo ? (
        <video
          src={filePath}
          style={{ width: "100%", height: "auto", maxWidth: "100%" }}
          autoPlay
          controls
          controlsList="nodownload"
        />
      ) : isCADSTEP ? (
        <STEPFileViewer fileUrl={filePath} />
      ) : isCADSTL ? (
        <STLFileViewer fileUrl={filePath} />
      ) : isCADDXF ? (
        <DXFFileViewer fileUrl={filePath} />
      ) : isWord || isPowerPoint ? (
        <iframe
          src={`https://docs.google.com/gview?url=${encodeURIComponent(filePath)}&embedded=true`}
          style={{
            width: "100%",
            height: "100vh",
            border: "none"
          }}
        />
      ) : isExcel ? (
        <iframe
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(filePath)}`}
          style={{
            width: "100%",
            height: "100vh",
            border: "none",
          }}
        />

      ) : (
        <>
          <DocViewer
            documents={docs}
            pluginRenderers={DocViewerRenderers}
            config={{
              header: {
                disableHeader: isHeaderDisabled,
                disableFileName: isHeaderDisabled,
                retainURLParams: isHeaderDisabled,
              },
            }}
            style={{ width: "100%", maxWidth: "100%", height: "100vh" }}
          />
          {!isImage && <div className="empty-container" />}
        </>
      )}
    </div>
  );
};

export default memo(AppFileViewer);
